import React from "react";
import styles from "./Footer.module.scss";
import Image from "next/image";

interface FooterCTAProps {
  className?: string;
}

const FooterCTA: React.FC<FooterCTAProps> = ({ className }) => (
  <section 
    className={`${styles["o-footer__cta"]} ${className || ""}`}
    aria-labelledby="footer-cta-title"
  >
    <div className={`${styles["c-footer-cta"]} ${styles["u-text-center"]}`}>
      <header className={styles["c-footer-cta__header"]}>
        <span className={`${styles["c-footer-cta__eyebrow"]} ${styles["u-mono-02"]} ${styles["u-uppercase"]}`}>
          Enter the stronghold
        </span>
        <h2 
          id="footer-cta-title" 
          className={`${styles["c-footer-cta__title"]} ${styles["u-bold-04"]}`}
        >
          Solflare: the most powerful wallet on Solana
        </h2>
      </header>
      
      <div className={styles["c-footer-cta__logo"]}>
        <Image 
          src="/tkn_lnd_pg_assets/logo.svg" 
          alt="Solflare logo" 
          width={64} 
          height={64}
          priority={false}
          loading="lazy"
        />
      </div>
      
      <nav className={styles["c-footer-cta__actions"]} aria-label="Download and access actions">
        <a 
          href="https://www.solflare.com/download/" 
          className={`${styles["c-button"]} ${styles["c-button--titanium"]}`}
          aria-label="Download Solflare wallet now"
        >
          <div>
            <span>Download now</span>
            <span aria-hidden="true">Download now</span>
          </div>
        </a>
        <a 
          href="https://solflare.com/onboard/" 
          className={`${styles["c-button"]} ${styles["c-button--titanium"]}`}
          target="_blank" 
          rel="noopener noreferrer"
          aria-label="Access Solflare wallet online"
        >
          <div>
            <span>Access wallet</span>
            <span aria-hidden="true">Access wallet</span>
          </div>
        </a>
      </nav>
    </div>
  </section>
);

export default FooterCTA; 